'use strict';

import defaultTemplate from '../../core/default.html';
import storiesViewTemplate from './stories.view.html';

import Stories from './stories.ctrl';

function StoriesRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.stories', {
      url: '/stories',
      template: defaultTemplate
    })
    .state('main.stories.view', {
      url: '/view?storyId&deviceModelId',
      template: storiesViewTemplate,
      controller: 'StoryViewController as vm',
      resolve: {
        checkParams: ($stateParams, $q, $log) => {
          if (!$stateParams.storyId) {
            $log.error('storyId query parameter should be set.');
            return $q.reject();
          }
          if ($stateParams.story && $stateParams.story.id && $stateParams.story.id.toString() !== $stateParams.storyId) {
            $log.error('storyId query parameter is illegal.');
            return $q.reject();
          }
          if ($stateParams.deviceModel &&
            $stateParams.deviceModel.id &&
            $stateParams.deviceModel.id.toString() !== $stateParams.deviceModelId) {
            $log.error('deviceModelId query parameter is illegal.');
            return $q.reject();
          }
        }
      },
      params: {
        story: null,
        deviceModel: null,
        availableStories: []
      }
    });
}

export default angular
  .module('stories.router', [
    Stories
  ])
  .config(StoriesRouter)
  .name;
